import server from "../../../server";



export async function fetchEmployeeAttendance(pageNumber: number, pageSize?: number, startDate?: string, endDate?: string,employeeId?:string, sortField?: string, sortDirection?: string,status?:string) {
    const res = await server.attendance.admin.list(pageNumber, pageSize ?? 10, startDate, endDate,employeeId, sortField, sortDirection,status);
    return res;
}

export async function fetchAttendanceCount(date: string) {
    const res = await server.attendance.admin.count(date);
    return res;
}

export async function fetchAttendanceChartData() {
    const res = await server.attendance.admin.chartData();
    return res;
}

export async function fetchPunchDetails(employeeId: string, startDate: string, endDate: string) {
    const res = await server.attendance.admin.getEmployeePunches(employeeId, startDate, endDate, 0, 20);
    return res;
}
